import { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Card, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getEvents } from '../../actions/other/eventsActions'
import { getForSelect } from '../../actions/other/lotsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../components/loaders/Loader'
import { useNavigate } from 'react-router-dom'

import EventFormAlta from '../../components/forms/events/EventFormAlta'
import EventFormBaja from '../../components/forms/events/EventFormBaja'
import EventFormMovement from '../../components/forms/events/EventFormMovement'
import EventFormReview from '../../components/forms/events/EventFormReview'
import EventFormReviewMark from '../../components/forms/events/EventFormReviewMark'
import EventFormBirthProcess from '../../components/forms/events/EventFormBirthProcess'
import EventFormAbort from '../../components/forms/events/EventFormAbort'
import EventFormWeaning from '../../components/forms/events/EventFormWeaning'
import EventFormWeight from '../../components/forms/events/EventFormWeight'
import EventFormInsemination from '../../components/forms/events/EventFormInsemination'
import EventFormSemental from '../../components/forms/events/EventFormSemental'

export default function EventHistorical() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()
    const navigate = useNavigate()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    const {events, resultevent, loading, total} = useSelector(state=>state.events)

    useEffect(() => {
        if(clientauth){
            dispatch(getEvents(page, limit, search))
            dispatch(getForSelect())
        }
    },[dispatch, t, clientauth])

    useEffect(() => {
        if (clientauth) {
            dispatch(getEvents(page, limit, search))
        }
    }, [page, limit, search])

    useEffect(() => {
        setTotalRows(total || 0)
    }, [total])

    const selectEvent = (event) => {
            const merged = {
            ...(event.payload || {}),
            ...event, // lo que esté en raíz sobrescribe payload si hay conflicto
        }
        setFormState(merged)
        setIsAddingOrEditing('editing')
        setModalShow(true)
    }

    const renderForm = () => {
        const type = formState?.type

        const props = {
            type,
            state: formState,
            handleInputChange: ({ target }) => {
                setFormState(prev => ({
                    ...prev,
                    [target.name]: target.value
                }))
            },
            submit: (e) => {
                e.preventDefault()
                // Aquí puedes reutilizar lógica si quieres permitir edición desde histórico
            },
            isRegistering,
            isAddingOrEditing
        }

        switch (type) {
            // ALTA
            case 'birth':
            case 'acquisition':
                return <EventFormAlta {...props} />

            // BAJA
            case 'death':
            case 'sacrifice':
            case 'desvieje':
            case 'sale':
                return <EventFormBaja {...props} />

            // OTROS
            case 'movement': return <EventFormMovement {...props} />
            case 'review': return <EventFormReview {...props} />
            case 'reviewMark':
            case 'status':
            case 'heat':
                return <EventFormReviewMark {...props} />
            case 'birthProcess': return <EventFormBirthProcess {...props} />
            case 'abort': return <EventFormAbort {...props} />
            case 'weaning': return <EventFormWeaning {...props} />
            case 'weight': return <EventFormWeight {...props} />
            case 'insemination': return <EventFormInsemination {...props} />
            case 'semental': return <EventFormSemental {...props} />

            default:
                return <h3>{t('breeder.event.invalidType')}</h3>
        }
    }

    useEffect(() => {
        if(resultevent){
            let resulteventnow = resultevent
            dispatch({ type: 'EVENT_RESET_RESULT' })
            switch (resulteventnow) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.event.addsuccess')
                    })
                    break;
                case 'needMoreData':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.event.needMoreData')
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.event.editSuccess')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultevent])

    const columnsEvent = [
        {
            name: t('event.type'),
            cell: event =>
                <div className='cursor' onClick={() => selectEvent(event)}>
                    {t('menus.event_' + event.type) || '—'}
                </div>,
            selector: (event) => event.identifier || '—',
            sortable: true,
        },{
            name: t('event.dateCreated'),
            cell: event =>
                <div className='cursor' onClick={() => selectEvent(event)}>
                    {(event?.dateCreated) ? new Intl.DateTimeFormat('es-ES', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(event?.dateCreated)) : '—'}
                </div>,
            selector: (event) => (event?.dateCreated) ? new Intl.DateTimeFormat('es-ES', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(event?.dateCreated)) : '—',
            sortable: true,
        },{
            name: t('global.actions'),
            width: '100px',
            cell: event =>
                <div className='cursor text-color2' onClick={() => selectEvent(event)}>
                    {t('global.details')}
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('event.events')}</h1>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    {loading ?
                        <Loader/>
                    :
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex my-2">
                                            <input
                                                type="text"
                                                className="form-control me-2"
                                                placeholder={t("datatables.buscar")}
                                                value={searchAux || ""}
                                                onChange={e => {
                                                    setSearchAux(e.target.value);
                                                    setPage(1);
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        if (search !== searchAux) {
                                                            setSearch(searchAux);
                                                            if (page !== 1) setPage(1);
                                                        }
                                                    }
                                                }}
                                            />
                                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                                        </div>
                                        {events?.length > 0 ?
                                            <CustomDataTable
                                                columns={columnsEvent}
                                                data={events}
                                                pagination
                                                paginationServer
                                                paginationResetDefaultPage={false}
                                                paginationDefaultPage={page}
                                                paginationTotalRows={totalRows}
                                                onChangeRowsPerPage={(newLimit, page) => {
                                                    if (limit !== newLimit) {
                                                        setLimit(newLimit)
                                                        setPage(1)
                                                    }
                                                }}
                                                onChangePage={(newPage) => {
                                                    setPage(newPage)
                                                }}
                                            />
                                        :
                                            <h4 className='mt-4'>{t('event.thereisnotevent')}</h4>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.animal.animal')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formState && formState.type ? renderForm() : <p>{t('global.loading')}...</p>}
                </Modal.Body>
            </Modal>
        </Container>
    )
}